var _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseEyeIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.42388 1.92188C4.62147 1.92188 3.1782 2.74376 2.12754 3.72197C1.08357 4.69125 0.385355 5.85261 0.05521 6.64992C-0.0184033 6.82636 -0.0184033 7.02289 0.05521 7.19933C0.385355 7.99664 1.08357 9.15799 2.12754 10.1273C3.1782 11.1055 4.62147 11.9274 6.42388 11.9274C8.22629 11.9274 9.66956 11.1055 10.7202 10.1273C11.7642 9.15576 12.4624 7.99664 12.7948 7.19933C12.8684 7.02289 12.8684 6.82636 12.7948 6.64992C12.4624 5.85261 11.7642 4.69125 10.7202 3.72197C9.66956 2.74376 8.22629 1.92188 6.42388 1.92188ZM3.21166 6.92462C3.21166 6.07167 3.55009 5.25366 4.1525 4.65053C4.75491 4.0474 5.57195 3.70857 6.42388 3.70857C7.27582 3.70857 8.09286 4.0474 8.69526 4.65053C9.29767 5.25366 9.6361 6.07167 9.6361 6.92462C9.6361 7.77757 9.29767 8.59559 8.69526 9.19872C8.09286 9.80184 7.27582 10.1407 6.42388 10.1407C5.57195 10.1407 4.75491 9.80184 4.1525 9.19872C3.55009 8.59559 3.21166 7.77757 3.21166 6.92462ZM6.42388 5.49527C6.42388 6.28365 5.78367 6.92462 4.99623 6.92462C4.83785 6.92462 4.68616 6.89782 4.54339 6.85092C4.42071 6.81072 4.27794 6.88666 4.2824 7.01619C4.28909 7.17029 4.3114 7.3244 4.35378 7.4785C4.65939 8.62198 5.83497 9.30093 6.9771 8.99496C8.11922 8.68899 8.79735 7.512 8.49175 6.36851C8.24414 5.44167 7.42547 4.81856 6.51534 4.78059C6.38596 4.77612 6.31012 4.91682 6.35027 5.04189C6.39711 5.18483 6.42388 5.3367 6.42388 5.49527Z",
    fill: "#CD2A3F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.18814,
    y: 1.11925,
    width: 1.8,
    height: 15.8,
    rx: 0.9,
    transform: "rotate(-33 1.18814 1.11925)",
    fill: "#CD2A3F",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEyeIconRed);
export default __webpack_public_path__ + "static/media/closeEyeIconRed.bfb851ba83114792429d7280406fcc3c.svg";
export { ForwardRef as ReactComponent };